import { render, staticRenderFns } from "./ChannelComponent.vue?vue&type=template&id=04032333&scoped=true&"
import script from "./ChannelComponent.vue?vue&type=script&lang=ts&"
export * from "./ChannelComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelComponent.vue?vue&type=style&index=0&id=04032333&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04032333",
  null
  
)

component.options.__file = "ChannelComponent.vue"
export default component.exports